import React, { useEffect, useState, createRef } from "react";
import PropTypes from "prop-types";

import go, { GraphObject, TreeLayout } from "gojs";
import {
	useTheme,
	Box,
	Backdrop,
	Snackbar,
	Alert,
	CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles/";

import { useDecodedToken } from "../Services/Routes/APP/PrivateRoute";
import UsersModal from "./UsersModal";
import { commonRoutes, RoutesUrls } from "../Services/Routes/APP";
import { titlizeString, ROLE_METHODS } from "../common/functions";
import { domain } from "../Services/Routes/API";
import { headersGet, headersPost } from "../Services/API";
import ConfirmationDialogue from "./ConfirmationDialogue";

const useStyles = makeStyles({
  menu: {
    display: "block",
    position: "absolute",
    opacity: 0,
    margin: 0,
    padding: "8px 0",
    zIndex: "999",
    boxShadow:
      "0 5px 5px -3px rgba(0, 0, 0, .2), 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 2px rgba(0, 0, 0, .12)",
    listStyle: "none",
    backgroundColor: "#ffffff",
    borderRadius: "4px",
  },
  menuItem: {
    display: "block",
    position: "relative",
    minWidth: "60px",
    margin: 0,
    padding: "6px 16px",
    font: "bold 12px sans-serif",
    color: "rgba(0, 0, 0, .87)",
    cursor: "pointer",
    "&::before": {
      position: "relative",
      top: 0,
      left: 0,
      opacity: 0,
      pointerEvents: "none",
      content: "",
      width: "100%",
      height: "100%",
      backgroundColor: "#000000",
    },
    "&:hover::before": {
      opacity: 0.04,
    },
  },
  showMenu: {
    display: "block",
	  opacity: 1,
	
  },
});

const $ = go.GraphObject.make;

const HierarchicalTree = ({ tree = [] }) => {
	debugger
	const theme = useTheme();
	const classes = useStyles();
	const user = useDecodedToken();
	const navigate = useNavigate();
	const goJsDiv = createRef();
	const NODE_PLANNER_LOGO_SOURCE = `data:image/svg+xml,<svg width='100' height='100' margin='auto' viewBox='-57 -38 400 450' fill='none' xmlns='http://www.w3.org/2000/svg' ><path d='M152.01 191.84L236.02 275.85' stroke='%23231F20' strokeWidth='4' strokeMiterlimit='10' /><path d='M136.77 201.19L52.7598 285.2' stroke='%23231F20' strokeWidth='4' strokeMiterlimit='10' /><path d='M149.49 54.1699V99.9999' stroke='%23231F20' strokeWidth='5' strokeMiterlimit='10' /><path d='M143.61 94.9398L195.36 79.2798L166.72 129.49C166.574 129.747 166.505 130.04 166.52 130.335C166.535 130.629 166.634 130.914 166.805 131.155C166.976 131.395 167.213 131.582 167.486 131.693C167.76 131.803 168.06 131.834 168.35 131.78L203.54 125.24L107.87 287.62L134.48 194.31C134.564 194.021 134.561 193.714 134.473 193.427C134.384 193.14 134.213 192.885 133.982 192.694C133.75 192.502 133.467 192.383 133.168 192.35C132.87 192.318 132.568 192.373 132.3 192.51L112.3 202.51L143.61 94.9398Z' fill='%23E9262B' stroke='%23231F20' strokeWidth='3' strokeMiterlimit='10' /><path d='M150.43 62.6C167.164 62.6 180.73 49.0342 180.73 32.3C180.73 15.5658 167.164 2 150.43 2C133.696 2 120.13 15.5658 120.13 32.3C120.13 49.0342 133.696 62.6 150.43 62.6Z' fill='%2377C044' stroke='%23231F20' strokeWidth='3' strokeMiterlimit='10' /><path d='M249.7 320.1C266.435 320.1 280 306.534 280 289.8C280 273.066 266.435 259.5 249.7 259.5C232.966 259.5 219.4 273.066 219.4 289.8C219.4 306.534 232.966 320.1 249.7 320.1Z' fill='%23FBB316' stroke='%23231F20' strokeWidth='3' strokeMiterlimit='10' /><path d='M32.3 320.1C49.0342 320.1 62.6 306.534 62.6 289.8C62.6 273.066 49.0342 259.5 32.3 259.5C15.5658 259.5 2 273.066 2 289.8C2 306.534 15.5658 320.1 32.3 320.1Z' fill='%2337A6DE' stroke='%23231F20' strokeWidth='3' strokeMiterlimit='10' /></svg>`;

	const [myDiagram, setMyDiagram] = useState(null);
	const [myModel, setMyModel] = useState(null);
	const [nodesTree, setNodesTree] = useState([]);
	const [selectedNodeData, setSelectedNodeData] = useState(null);

	const [nodeStatusModaEditDialogueOpen, setNodeStatusModaEditDialogueOpen] =
		useState(false);
	const [modalUsers, setModalUsers] = useState([]);
	const [usersModalOpen, setUsersModalOpen] = useState(false);

	const [loaderOpen, setLoaderOpen] = useState(false);
	const [alertOpen, setAlertOpen] = useState(false);
	const [alertMsg, setAlertMsg] = useState("");
	const [alertIcon, setAlertIcon] = useState("error");

	const [logoSource, setLogoSource] = useState("");

	const renderCanvas = (diagram) => {
		const levelColors = ["#AC193D", "#2672EC", "#8C0095", "#5133AB"];

		// override TreeLayout.commitNodes to also modify the background brush based on the tree depth level
		diagram.layout.commitNodes = () => {
			go.TreeLayout.prototype.commitNodes.call(diagram.layout); // do the standard behavior
			// then go through all of the vertexes and set their corresponding node's Shape.fill
			// to a brush dependent on the TreeVertex.level value
			diagram.layout.network.vertexes.each((v) => {
				if (v.node) {
					const level = v.level % levelColors.length;
					const color = levelColors[level];
					const shape = v.node.findObject("SHAPE");
					if (level === 0) {
            // GraphObject.position(200 , 200);
        //   GraphObject.Part.location(200 , 200);
            // 		  diagram = $(
            //     go.Diagram,
            //     "diagram",
            //     {
            //       initialContentAlignment: go.Spot.Center,
            //     }
            //   );
            // locationSpot: go.Spot.Center;
						
						
			// 			diagram.model.nodeDataArray = [
            //   { key: 1, loc: "0 0" },
              
            // ];
          }
					
					if (shape)
						shape.stroke = $(go.Brush, "Linear", {
							0: color,
							1: go.Brush.lightenBy(color, 0.05),
							start: go.Spot.Top,
							end: go.Spot.Bottom,
							
						});
				}
			});
		};

		// define the Link template
		diagram.linkTemplate = $(
			go.Link,
			{	
				routing: go.Link.Orthogonal,
				corner: 5,
				layerName: "Background",
			},
			$(go.Shape, {
				strokeWidth: 1.5,
				stroke: "#c7c9ca",
			})
		); // the link shape

		// This is the actual HTML context menu:
		let cxElement = document.getElementById("contextMenu");
		// document.addEventListener('body', event => event.preventDefault());
	// 	document.addEventListener(
    //   "contextmenu",
    //   function (event) {
    //     event.preventDefault();
	// 	 alert(" right click is disabled ")
	
    //   },
    //   false
    // );

		// an HTMLInfo object is needed to invoke the code to set up the HTML cxElement
		let myContextMenu = $(go.HTMLInfo, {
			show: (event, node) => showContextMenu(event, node),
			hide: (diagramInstance) => hideContextMenu(diagramInstance),
		});

		diagram.contextMenu = myContextMenu;

		cxElement.addEventListener(
			"contextmenu",
			(e) => {
				e.preventDefault();
				return false;
			},
			false
		);

		function showContextMenu(e, node) {
			const diagramInstance = e?.diagram;
			const nodeData = node?.part?.data;
			// Show only the relevant buttons given the current state.
			let hasMenuItem = false;
			function maybeShowItem(el, show) {
				if (show) {
					el.style.display = "block";
					hasMenuItem = true;
				} else {
					el.style.display = "none";
				}
			}
			maybeShowItem(
				document.getElementById("add-node"),
				nodeData?.role === user?.role
			);
			maybeShowItem(
				document.getElementById("edit-node"),
				ROLE_METHODS.appBasedRole(nodeData?.role) ===
					ROLE_METHODS.getAppBased1stChildRole(user?.role)
			);
			maybeShowItem(
				document.getElementById("active-inactive-node"),
				ROLE_METHODS.appBasedRole(nodeData?.role) ===
					ROLE_METHODS.getAppBased1stChildRole(user?.role)
			);
			maybeShowItem(document.getElementById("node-details"), true);
			maybeShowItem(document.getElementById("list-users"), true);
			// maybeShowItem(document.getElementById("color"), obj !== null);

			// Now show the whole context menu element
			if (hasMenuItem) {
				cxElement.classList.add(classes.showMenu);
				// we don't bother overriding positionContextMenu, we just do it here:
				const event = e?.event;
				const { bottom, right } = diagramInstance?.div?.getBoundingClientRect();
				const { height, width } = cxElement.getBoundingClientRect();
				const { clientX, clientY } = event;

				const CX_HEIGHT = height;
				const CX_WIDTH = width;
				const CLICK_X = clientY;
				const CLICK_Y = clientX;
				const DIV_RIGHT = right;
				const DIV_BOTTOM = bottom;

				cxElement.style.top =
					(DIV_BOTTOM - CLICK_X >= CX_HEIGHT ? CLICK_X : CLICK_X - CX_HEIGHT) -
					120 +
					"px";
				cxElement.style.left =
					(DIV_RIGHT - CLICK_Y >= CX_WIDTH ? CLICK_Y : CLICK_Y - CX_WIDTH) -
					20 +
					"px";
			} 
			// Optional: Use a `window` pointerdown listener with event capture to
			//           remove the context menu if the user clicks elsewhere on the page
			window.addEventListener(
				"pointerdown",
				diagramInstance?.contextMenu?.hide,
				true
			);
		}

		function hideContextMenu(diagramInstance) {
			cxElement.classList.remove(classes.showMenu);
			// Optional: Use a `window` pointerdown listener with event capture to
			//           remove the context menu if the user clicks elsewhere on the page
			window.removeEventListener(
				"pointerdown",
				diagramInstance?.contextMenu?.hide,
				true
			);
		}

		diagram.nodeTemplate = $(
      go.Node,
      "Spot",
      {
		  isTreeExpanded: false,
		  
		  
      },
      $(
        go.Panel,
        "Auto",
        $(go.Shape, "RoundedRectangle", {
          contextMenu: myContextMenu,
          //box styling

          name: "SHAPE",
          fill: "white",
			portId: "",
		
        }),
        $(
          go.Panel,
          "Horizontal",
          {
            minSize: new go.Size(225, 70),
            maxSize: new go.Size(300, 70),
            defaultAlignment: go.Spot.Left,
          },
          $(
            go.Panel,
            "Spot",
            {
              isClipping: true,
              margin: 10,
            },
            $(go.Shape, "Circle", {
              desiredSize: new go.Size(50, 50),
            }),
            $(go.Picture, {
              source: logoSource || NODE_PLANNER_LOGO_SOURCE,
              background: "#f4f7f9",
              desiredSize: new go.Size(51, 51),
            })
          ),
          $(
            go.Panel,
            "Vertical",
            {
              desiredSize: new go.Size(180, NaN),
            },
            $(
              go.TextBlock, // name
              {
                text: "alignment: Left",
                font: "12pt Segoe UI,sans-serif",
                alignment: go.Spot.Left,
                editable: true,
                isMultiline: false,
                stroke: "black",
              },
              new go.Binding("text", "name").makeTwoWay()
            ),
            $(
              go.TextBlock, // role
              {
                text: "alignment: Left",
                font: "9pt Segoe UI,sans-serif",
                alignment: go.Spot.Left,
                editable: true,
                isMultiline: false,
                stroke: "#c7c9ca",
              },
              new go.Binding("text", "role", (text) => {
                return titlizeString(ROLE_METHODS.appBasedRole(text));
              })
            )
          ),
          $(
            go.Panel,
            "Auto",
            {
              cursor: "pointer",
              click: (e, node) => {
                const nodeData = node?.part?.data;
                setSelectedNodeData(nodeData);
				  e.diagram.contextMenu.show(e, node);
				//   e.preventDefault();
				  
              },
            },
            $(go.Shape, "RoundedRectangle", {
              desiredSize: new go.Size(20, 8),
              margin: new go.Margin(0, 2, 58, 0),
              fill: "#dfdfdf",
              stroke: "#dfdfdf",
				strokeWidth: 2,
			
            }),
            $(
              go.Panel,
              "Horizontal",
              $(go.Shape, "Circle", {
                desiredSize: new go.Size(3, 3),
                margin: new go.Margin(0, 2, 0, 0),
                fill: "white",
                stroke: "white",
              }),
              $(go.Shape, "Circle", {
                desiredSize: new go.Size(3, 3),
                fill: "white",
                stroke: "white",
              }),
              $(go.Shape, "Circle", {
                desiredSize: new go.Size(3, 3),
                margin: new go.Margin(0, 0, 0, 2),
                fill: "white",
                stroke: "white",
              })
            )
          )
        )
			),
	  
			$(
				"TreeExpanderButton",
				{
					_treeExpandedFigure: "MinusLine",
					_treeCollapsedFigure: "PlusLine",
					"ButtonBorder.figure": "Circle",
					alignment: go.Spot.Bottom,
					alignmentFocus: go.Spot.Center,
				},
				
				{ visible: true }
			),
			{
				selectionAdornmentTemplate: $(
					go.Adornment,
					"Auto",
					$(go.Shape, "RoundedRectangle", {
						fill: null,
						stroke: "transparent",
						strokeWidth: 0,
					}),
					$(go.Placeholder)
				), // end Adornment
			}
		);
	};


	const handleUsersModalClose = () => {
		setUsersModalOpen(false);
		setModalUsers([]);
	};

	const handleNodeStatusModaEditDialogueClose = () => {
		setNodeStatusModaEditDialogueOpen(false);
	};

	const handleAlertClose = () => {
		setAlertOpen(false);
		setAlertMsg("");
		setAlertIcon("error");
	};

	const addActionHandler = () => {
		const appBasedUserRole = ROLE_METHODS.appBasedRole(user?.role);
		navigate(
			`/${appBasedUserRole}/${ROLE_METHODS.pluralizeRole(
				ROLE_METHODS.getAppBased1stChildRole(appBasedUserRole)
			)}/add`
		);
	};

	const detailsAction = () => {
		navigate(
			`/${ROLE_METHODS.appBasedRole(user?.role) + commonRoutes?.node?.details}`,
			{
				state: {
					detailsType: "node",
					detailsData: selectedNodeData,
				},
			}
		);
	};

	const editAction = () => {
		
		navigate(
			`/${ROLE_METHODS.appBasedRole(user?.role)}/${ROLE_METHODS.pluralizeRole(
				ROLE_METHODS.appBasedRole(selectedNodeData?.role)
			)}/edit`,
			{
				state: {
					node: selectedNodeData,
				},
				
			}
		);
	};

	const usersAction = () => {
		setModalUsers(selectedNodeData?.users);
		setUsersModalOpen(true);
	};

	const activeInactiveToggle = () => {
		setNodeStatusModaEditDialogueOpen(true);
	};

	const updateActiveToggle = (node) => {
		const data = {
			[node?.role]: {
				id: node?.id,
				is_active: !node?.is_active,
			},
		};
		setLoaderOpen(true);

		headersPost(ROLE_METHODS.roleBasedAPIRoute(node?.role) + "/update", data)
			.then((res) => {
				setLoaderOpen(false);
				setNodeStatusModaEditDialogueOpen(false);
				if (res?.status === 200 && res?.data?.success) {
					setAlertMsg(res?.data?.message);
					setAlertIcon("success");
					setAlertOpen(true);
					let updatedNodeData = selectedNodeData;
					updatedNodeData.is_active = !selectedNodeData?.is_active;
					setSelectedNodeData({ ...selectedNodeData, ...updatedNodeData });
				} else {
					setAlertOpen(true);
					setAlertMsg(res?.data?.message);
					setAlertIcon("warning");
				}
			})
			.catch((err) => {
				setLoaderOpen(false);
				const { response } = err;
				if (response?.status === 401) {
					localStorage.clear();
					navigate(RoutesUrls?.root);
				} else {
					setAlertOpen(true);
					setAlertMsg(response?.statusText);
					setAlertIcon("error");
				}
			});
	};

	useEffect(() => {
		
		if (tree?.length && tree !== nodesTree && myModel && myDiagram) {
			const model = myModel;
			const diagram = myDiagram;
			model.nodeDataArray = tree;
			diagram.model = model;

	// 		diagram.model = new go.GraphLinksModel(

				

	// 			tree.map((row , index) => {
	// 				return { key: row[index]?.key} 
	// 			})
	// 					[{ from: tree?.key - tree?.key, to: tree?.key }]
				
    //   );
		
	// 		diagram.model = new go.GraphLinksModel(
    //     [{ key: 1 }, { key: 2 }],
    //     [{ from: 1, to: 2 }]
    //   );
		
			setNodesTree(tree);
			setMyDiagram(diagram);
			setMyModel(model);

		}
	}, [myModel, myDiagram, tree]);

	

	useEffect(() => {
		
		const treeViewDiagram = $(go.Diagram, goJsDiv.current, {
      allowCopy: false,
      allowDelete: false,
      allowMove: false,
      // initialContentAlignment: go.Spot.Center,
			// contextMenuTool.isEnabled: false,
	//   contextMenuTool.isEnabled:false,
	   "contextMenuTool.isEnabled": false,

      layout: $(go.TreeLayout, {
        treeStyle: go.TreeLayout.StyleLastPartreeViewDiagraments,
        // arrangement: go.TreeLayout.ArrangementHorizontal,
		  arrangement: go.TreeLayout.ArrangementFixedRoots,
		

        // TreeLayout.arrangement : go.TreeLayout.ArrangementFixedRoots,

        angle: 90,
        layerSpacing: 40,
        alternateAngle: 90,
        alternateLayerSpacing: 40,
        alternateAlignment: go.TreeLayout.AlignmentBus,
        alternateNodeSpacing: 20,
      }),
      "undoManager.isEnabled": true, // enable undo & redo
    });
		const treeModel = $(go.TreeModel);

		if (!myDiagram) {
			setMyDiagram(treeViewDiagram);
		}
		if (!myModel) {
			setMyModel(treeModel);
		}

		const LOGO_URL = user?.logo?.url;
		if (LOGO_URL) {
			const IMAGE_URL = domain + LOGO_URL;
			headersGet(IMAGE_URL)
				.then((response) => {
					if (response?.status === 200) {
						setLogoSource(IMAGE_URL);
					} else {
						setLogoSource("");
					}
				})
				.catch(() => {
					setLogoSource("");
				});
		} else {
			setLogoSource("");
		}

		renderCanvas(myDiagram || treeViewDiagram);
	}, []);

	return (
		<>
			<Box
				ref={goJsDiv}
				sx={{ width: "100%", height: "inherit", border: "none" }}
			></Box>
			<ul
				id="contextMenu"
				className={`${classes.menu}`}
				style={{ left: "238.5px", top: "236px"  }}
			>
				<li
					id="add-node"
					className={classes.menuItem}
					onPointerDown={addActionHandler}
					style={{ display: "block" }}
				>
					{"Add " +
						ROLE_METHODS.pluralizeRole(
							ROLE_METHODS.getAppBased1stChildRole(user.role)
						)}
				</li>
				<li
					id="edit-node"
					className={classes.menuItem}
					onPointerDown={editAction}
					style={{ display: "block" }}
				>
					{"Edit " + ROLE_METHODS.appBasedRole(selectedNodeData?.role)}
				</li>
				<li
					id="active-inactive-node"
					className={classes.menuItem}
					onPointerDown={activeInactiveToggle}
					style={{ display: "block" }}
				>
					{(selectedNodeData?.is_active ? "Active " : "Inactive ") +
						ROLE_METHODS.appBasedRole(selectedNodeData?.role)}
				</li>
				<li
					id="node-details"
					className={classes.menuItem}
					onPointerDown={detailsAction}
					style={{ display: "block" }}
				>
					{"Details"}
				</li>
				<li
					id="list-users"
					className={classes.menuItem}
					onPointerDown={usersAction}
					style={{ display: "none" }}
				>
					{"List users"}
				</li>
			</ul>
			<UsersModal
				users={modalUsers}
				onClose={handleUsersModalClose}
				open={usersModalOpen}
			/>
			<ConfirmationDialogue
				data={selectedNodeData}
				open={nodeStatusModaEditDialogueOpen}
				handleClose={handleNodeStatusModaEditDialogueClose}
				confirmHandler={() => {
					updateActiveToggle(selectedNodeData);
				}}
			/>
			<Backdrop
				sx={{
					zIndex: theme.zIndex.drawer + 1,
					color: theme.palette.primary.main,
				}}
				open={loaderOpen}
			>
				<CircularProgress color="inherit" />
			</Backdrop>
			<Snackbar
				open={alertOpen}
				autoHideDuration={6000}
				onClose={handleAlertClose}
				anchorOrigin={{ vertical: "top", horizontal: "center" }}
			>
				<Alert onClose={handleAlertClose} severity={alertIcon}>
					{alertMsg}
				</Alert>
			</Snackbar>
		</>
	);
};

export default HierarchicalTree;

HierarchicalTree.propTypes = { tree: PropTypes?.array?.isRequired };
HierarchicalTree.defaultProps = { tree: [] };







<style></style>;
